import React from 'react';
import { Box, } from '@waglabs/box-next';
import { Typography } from '@waglabs/typography';
export const Chip = ({ value, children, textProps, ...rest }) => (React.createElement(Box, Object.assign({ borderRadius: "16px", display: "inline-flex", border: "1px solid black", verticalAlign: "center", justifyContent: "center", textDecoration: "none", style: {
        whiteSpace: 'nowrap',
    } }, rest), children || (React.createElement(Typography, Object.assign({ variant: "body2", px: "12px", py: "4px", color: "#3A5080", fontWeight: "bold" }, textProps), value))));
